module.exports = __webpack_public_path__ + "img/iconNo11.49daa424.png";